import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCarGeneration } from './carThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCarKey } from '../../sell/sellKeys';
const SLICE_NAME = 'generation';

export const generationSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCarGeneration(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCarGeneration });
        builder.addCase(clearCarKey, () => commonInitialState);
    },
});

export const { clearCarGeneration } = generationSlice.actions;

export const generation = generationSlice.reducer;
